var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoorHealthWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12671",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12672",
    d: "M12 4.925A5.343 5.343 0 0116.158 3c3.571 0 5.967 3.352 5.967 6.474C22.125 16 14 21 12 21S1.875 16 1.875 9.474C1.875 6.352 4.271 3 7.842 3A5.343 5.343 0 0112 4.925z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12673",
    d: "M7 11.5h2.222L10.889 9l2.222 5 1.667-2.5H17",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
export default SvgPoorHealthWhite;


//////////////////
// WEBPACK FOOTER
// ./src/icons/poorHealthWhite.svg
// module id = 776
// module chunks = 13